import style from './LogIn.module.css'
import { useDispatch, useSelector } from 'react-redux'
// import { loginThunk, authThunk } from '../../Redux/Slices/User/thunks'
import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { loginThunk } from '../../Redux/Slices/User/thunks'
import {ReactComponent as Eye} from '../../Assets/icons/viewPass.svg'
import {ReactComponent as EyeOff} from '../../Assets/icons/hiddenPass.svg'

export function LogIn(){
    const [statePassword, setStatePassword] = useState('password')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const ref = useRef(null)
    const [values, setValues] = useState({username : '', password: ''})
    const [error, setError] = useState('')

    async function handleSubmit(e){
        e.preventDefault()
        if(values.username === '' || values.password === '' || !ref.current) return
        dispatch(loginThunk(new FormData(ref.current))).then((data) =>{
            console.log(data);
            if(data.payload.detail) {
                setError(data.payload.detail)
            }else{
                setError('')
                navigate('/')
            }
            
        })
    }

    function handleInput (e){
        setValues({...values, [e.target.name] : e.target.value})
    }

    return <div className={style.LogIn}>
        <div className={style.wrapper}>
            <form ref={ref} onSubmit={handleSubmit} className={style.form}>
                <label>Login:</label>
                <input onInput={handleInput} name='username' value={values.username} placeholder='Enter your login' type="text" />
                <p className={style.error}></p>
                <label>Password:</label>
                <div className={style.password__container}>
                    <input onInput={handleInput} name='password' type={statePassword} value={values.password} placeholder='Enter your password' />
                    <div className={style.eye}>
                        {statePassword === 'password' ? <Eye onClick={() => setStatePassword('text')} /> : <EyeOff onClick={() => setStatePassword('password')} />}
                    </div>
                </div>
                <p className={style.error}></p>
                <button>Войти</button>
                <p className={style.server_error}>{error}</p>
            </form>
        </div>
    </div>
}